export function Logo({ type = `color` }) {
  return (
    <img
      className={ `h-8 w-auto` }
      src={ `/img/logo-${type}.png` }
      alt={ `Paidnice` }
    />
  );
}
